export default __webpack_public_path__ + "static/media/grafema_angura_14.fb62fa98.mp4";